import React from "react";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';

import ReactPasswordStrength from "react-password-strength";

import ic_show from "assets/images/ic_show.svg";
import ic_hide from "assets/images/ic_hide.svg";
import ic_login_hide from "assets/images/ic_login_hide.svg";
import ic_login_show from "assets/images/ic_login_show.svg";


import { FormInput } from "./FormInput";

import { func_validation } from "functions";



/* Props 
 * {
 *      // Label
 *      isInputOptional: false,
 *      isLabelOptional: false,
 *      inputLabel: "", 
 *      inputSideLabel: "", 
 * 
 *      // Input
 *      inputName: "",
 *      inputValue: "",
 * 
 *      // Input Options
 *      customInputType: "password",
 *      passwordStrengthOptions: {},
 *      inputMaxLength: 524288 (default Max),
 *      inputPlaceholder: "",
 *      isInputDisabled: false, 
 *      isInputSimplified: false,
 * 		toClearInput: false, 
 * 		toClearInputParentState: "",
 * 
 *      // Input Handling
 *      isInputClickHandlingRequired: false,
 *      isInputFocusHandlingRequired: false,
 *      isInputKeyPressHandlingRequired: false,
 *      isInputBlurHandlingRequired: false,
 * 
 *      // Custom Input Validation
 *      customValidator_onChange: (value_formatted)=>{ return value; },
 *      isValuePropagationGuarded_onChange: (value_formatted)=>{ return true/false; },
 * 
 *      // Input Propagation
 *      inputStateName: undefined,
 *      propagateValueChange: (inputStateName, value_formatted)=>{},
 *      handleInputClickExtend: (e)=>{}, 
 *      handleInputFocusExtend: (e)=>{}, 
 *      handleInputKeyPressExtend: (e)=>{},
 *      handleInputChangeExtend: (value_formatted)=>{},
 *      handleInputBlurExtend: ()=>{},
 * 
 *      // Error Display
 *      isErrorOptional: false,
 *      isFormSubmissionAttempted: false,
 * 
 *      // Error Checking
 *      customErrorMsgDefault: "",
 *      customErrorValidation: undefined,
 *      customErrorMsg: "",
 * 
 *      // Custom Error
 *      isInputHasError: false,
 *      customErrorDisplayArray: [{ isError: true|false, errorMsg: "" }],
 * 
 *      // Others
 *      className: "",
 *      customInputClassName: "",
 *      formInputCustomTheme: "component-formInputTheme_default",
 *      isMarginBtmOptional: false,
 *      inputCustomOptions: {},
 * }
 */

class FormInput_passwordPresentation extends React.Component {
	constructor(props) {
		super(props);
        this.state = {
            isPasswordVisible: false,
        };

        this.handleInputClick = this.handleInputClick.bind(this);
        this.handleInputFocus = this.handleInputFocus.bind(this);
        this.handleInputKeyPress = this.handleInputKeyPress.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleInputBlur = this.handleInputBlur.bind(this);
        
        this.handleInputClick_plain = this.handleInputClick_plain.bind(this);
        this.handleInputFocus_plain = this.handleInputFocus_plain.bind(this);
        this.handleInputKeyPress_plain = this.handleInputKeyPress_plain.bind(this);
        this.handleInputChange_plain = this.handleInputChange_plain.bind(this);
        this.handleInputBlur_plain = this.handleInputBlur_plain.bind(this);

        this.resetPasswordField = React.createRef();
    }

    componentDidUpdate() {
        const { toClearInput, toClearInputParentState } = this.props;
		if (func_validation.isBooleanTrueNotNullUndefined(toClearInput) && 
			func_validation.isStringTrimNotEmpty(toClearInputParentState) && 
			this.resetPasswordField) {
			
            // Clear React-password-strength input field through ref
            this.resetPasswordField.current.clear();
            
            // Update password state in parent, along with validity of password
            if (this.props.propagateValueChange) {
                this.props.propagateValueChange(toClearInputParentState, false);
            }
        }
    }

    handleInputClick(e) {
        // Extension
        if (this.props.handleInputClickExtend) this.props.handleInputClickExtend(e);
    }

    handleInputFocus(e) {
        // Extension
        if (this.props.handleInputFocusExtend) this.props.handleInputFocusExtend(e);
    }

    handleInputKeyPress(e) {
        // Extension
        if (this.props.handleInputKeyPressExtend) this.props.handleInputKeyPressExtend(e);
    }

    handleInputChange(passwordObj) {
        const { inputStateName, inputMaxLength } = this.props;

        // Value
        // const { score, password, isValid } = passwordObj;
        let value_formatted = passwordObj;
        
        // Max Length (Truncate)
        let passwordValue = func_validation.getObjectPropertyValue(passwordObj, "password", "");
        if (inputMaxLength) value_formatted["password"] = func_validation.getTruncatedString(passwordValue, inputMaxLength);
        
        // Custom Validator
        if (this.props.customValidator_onChange) value_formatted = this.props.customValidator_onChange(value_formatted);

        // Update parent state
        if (this.props.propagateValueChange) {
            if (this.props.isValuePropagationGuarded_onChange) {
                if (this.props.isValuePropagationGuarded_onChange(value_formatted)) this.props.propagateValueChange(inputStateName, value_formatted);
            }
            else this.props.propagateValueChange(inputStateName, value_formatted);
        }
        
        // Extension
        if (this.props.handleInputChangeExtend) this.props.handleInputChangeExtend(value_formatted);
    }

    handleInputBlur() {
        // Extension
        if (this.props.handleInputBlurExtend) this.props.handleInputBlurExtend();
    }

    handleInputClick_plain(e) {
        // Extension
        if (this.props.handleInputClickExtend) this.props.handleInputClickExtend(e);
    }

    handleInputFocus_plain(e) {
        // Extension
        if (this.props.handleInputFocusExtend) this.props.handleInputFocusExtend(e);
    }

    handleInputKeyPress_plain(e) {
        const { isInputValueTrim_onChange, isFocusRemovedOnEnterKey, isInputDigitOnly, isConvertedToNumber } = this.props;

        // Value
        const { value } = e.target;
        let value_formatted = value;

        // Digit only
        if (isInputDigitOnly) {
            value_formatted = value_formatted.replace(/[^0-9]/g, "");
            if (isConvertedToNumber &&
                func_validation.isStringTrimNotEmpty(value_formatted)) 
                value_formatted = parseInt(value_formatted);
        }

        if (isInputValueTrim_onChange) value_formatted = func_validation.getTrimmedString(value_formatted);

        // On Enter
        if (func_validation.isStringEqual_caseInsensitive(e.key, "Enter") &&
            this.props.handleInputEnterKeyPress) {
            this.props.handleInputEnterKeyPress(value_formatted);

            if (isFocusRemovedOnEnterKey) e.target.blur();
        }

        if (this.props.handleInputKeyPress) this.props.handleInputKeyPress(e, value_formatted);

        // Extension
        if (this.props.handleInputKeyPressExtend) this.props.handleInputKeyPressExtend(e, value_formatted);
    }

    handleInputChange_plain(e) {
        const { inputStateName, inputMaxLength } = this.props;

        // Value
        const { value } = e.target;
        let value_formatted = value;

        // Max Length (Truncate)
        if (inputMaxLength) value_formatted = func_validation.getTruncatedString(value_formatted, inputMaxLength);
        
        // Custom Validator
        if (this.props.customValidator_onChange) value_formatted = this.props.customValidator_onChange(value_formatted);

        // Update parent state
        if (this.props.propagateValueChange) {
            if (this.props.isValuePropagationGuarded_onChange) {
                if (this.props.isValuePropagationGuarded_onChange(value_formatted)) this.props.propagateValueChange(inputStateName, value_formatted);
            }
            else this.props.propagateValueChange(inputStateName, value_formatted);
        }
        
        // Extension
        if (this.props.handleInputChangeExtend) this.props.handleInputChangeExtend(value_formatted);
    }

    handleInputBlur_plain() {
        // Extension
        if (this.props.handleInputBlurExtend) this.props.handleInputBlurExtend();
    }

    handleOnClick_forgotPassword() {
        if (this.props.handleOnClick_forgotPassword) this.props.handleOnClick_forgotPassword();
    }

    render() {
        const { className, customInputClassName, formInputCustomTheme, isMarginBtmOptional, inputCustomOptions, 
                // Label
                isLabelOptional, inputLabel, isInputSideLabelVisible, isInputSideIconVisible, inputSideLabel, isInputOptional, isSideIconDark,
                // Input
                inputName, inputValue, customInputType, 
                passwordStrengthOptions, inputMaxLength, inputPlaceholder, isInputDisabled, 
                isInputSimplified, 
                // Input Handling
                isInputClickHandlingRequired, isInputFocusHandlingRequired, isInputKeyPressHandlingRequired, isInputBlurHandlingRequired, 
                // Error Checking
                isErrorOptional, 
                isFormSubmissionAttempted, 
                customErrorMsgDefault, customErrorValidation, customErrorMsg,
                isInputHasError, customErrorDisplayArray,
                // Forgot Password
                isForgotPasswordRequired, forgotPasswordClassName,
            } = this.props;

        const { isPasswordVisible } = this.state;

        // Label
        let inputLabelDisplay = (
            <span className="component-formInput-label">
                {inputLabel}
                {(isInputOptional)?"":(<span className="component-formInput-labelAsterisk">*</span>)}
            </span>
        );

        // SideLabel
        let inputSideLabelDisplay = (
            <span className="component-formInput-sideLabel">
                {inputSideLabel}
            </span>
        );

        // Input Type
        let customInputType_formatted = isPasswordVisible? "text":"password";
        
        // ReactPasswordStrength options
        let passwordStrengthOptions_formatted = func_validation.isObjectNotEmpty(passwordStrengthOptions)?passwordStrengthOptions:{};

        // Error Values
        let isError = false;
        let errorMsg = "";
        
        // Error Checking (Default)
        isError = (isFormSubmissionAttempted && !inputValue);
        errorMsg = (func_validation.isStringTrimNotEmpty(customErrorMsgDefault))?customErrorMsgDefault:"Input is Required";
        
        // Custom Error Checking (Empty)
        if (func_validation.isNotNullUndefined(customErrorValidation)) {
            isError = (customErrorValidation);
            errorMsg = (isError && func_validation.isStringTrimNotEmpty(customErrorMsg))?
                        customErrorMsg:errorMsg;
        }
        
        // Error Display
        let errorDisplay = (isError)?(<span className="component-formInput-errorMessage">{errorMsg}</span>):"";
        
        // Custom Error for Input
        let isInputHasError_formatted = func_validation.isBooleanTrueNotNullUndefined(isInputHasError);

        // Custom Error Display
        let customErrorDisplay = "";
        if (func_validation.isArrayNotEmpty(customErrorDisplayArray)) {
            customErrorDisplay = customErrorDisplayArray.map((customErrorDisplayItem, idx)=>{
                let isError_custom = func_validation.getObjectPropertyValue(customErrorDisplayItem, "isError", false);
                let errorMsg_custom = func_validation.getObjectPropertyValue(customErrorDisplayItem, "errorMsg", "");
                if (func_validation.isBooleanTrueNotNullUndefined(isError_custom) && 
                    func_validation.isStringTrimNotEmpty(errorMsg_custom)) {
                    return (<span className="component-formInput-errorMessage" key={idx}>{errorMsg_custom}</span>);
                }
            });
        }

        // Input Options
        let inputCustomOptions_formatted = (func_validation.isObjectNotEmpty(inputCustomOptions)?inputCustomOptions:{});
        
        return (
            <FormInput className={""+((className)?className+" ":"")+
                                       ((formInputCustomTheme)?formInputCustomTheme+" ":"component-formInputTheme_default ")} 
                isMarginBtmOptional={isMarginBtmOptional}>
                
                <div className="component-formInputPassword">

                    {/* Label */}
                    {(isLabelOptional)?"":(
                        (inputSideLabel)?(
                            <div className="component-formInput-labelGroup d-flex align-items-center justify-content-between">
                                {inputLabelDisplay}
                                {isInputSideLabelVisible? inputSideLabelDisplay:""}
                            </div>
                        ):inputLabelDisplay
                    )}
                    
                    {/* Input */}
                    {(isInputSimplified)?(
                        <div className={"component-formInput-inputWrapper"}>
                            <input type={customInputType_formatted}
                                className={"component-formInput-input "+
                                    ((customInputClassName)?customInputClassName+" ":"")+
                                    (((isError || isInputHasError_formatted) && !isErrorOptional)?"component-formInput-inputHasError ":"") + 
                                    (isInputSideIconVisible? "component-formInput_iconPadding ":"")} 
                                name={inputName} value={inputValue}

                                onClick={(e)=>{ if (isInputClickHandlingRequired) this.handleInputClick_plain(e); }}
                                onFocus={(e)=>{ if (isInputFocusHandlingRequired) this.handleInputFocus_plain(e); }} 
                                onKeyPress={(e)=>{ if (isInputKeyPressHandlingRequired) this.handleInputKeyPress_plain(e); }}
                                onChange={(e)=>{ this.handleInputChange_plain(e); }}
                                onBlur={(e)=>{ if (isInputBlurHandlingRequired) this.handleInputBlur_plain(e); }} 

                                maxLength={(inputMaxLength)?inputMaxLength:524288} 
                                placeholder={(inputPlaceholder)?inputPlaceholder:""} 
                                disabled={(isInputDisabled)} 
                                
                                {...inputCustomOptions_formatted}
                            />

                            {/* Side Icon */}
                            {isInputSideIconVisible? (
                                <div className={"component-formInputPassword-input-sideIcon d-flex align-items-center"}>
                                    {(isPasswordVisible? (
                                        <span className={"component-formInputPassword-input-sideIcon_hide"}
                                            onClick={() => { this.setState({ isPasswordVisible: false }); }}
                                        >
                                            <img
                                                src={isSideIconDark? ic_login_hide: ic_hide}
                                                alt={"Hide password icon"}
                                            />
                                        </span>
                                    ) : (
                                        <span className={"component-formInputPassword-input-sideIcon_show"} 
                                            onClick={() => { this.setState({ isPasswordVisible: true }); }}
                                        >
                                            <img
                                                src={isSideIconDark? ic_login_show: ic_show}
                                                alt={"Show password icon"}
                                            />
                                        </span>
                                    ))}
                                </div>
                            ):""}
                        </div>
                    ):(
                        <ReactPasswordStrength
                            className="component-formInputPassword-reactPasswordStrength d-block" 
                            inputProps={{ 
                                type: customInputType_formatted,
                                className: "component-formInput-input "+
                                            ((customInputClassName)?customInputClassName+" ":"")+
                                            (((isError || isInputHasError_formatted) && !isErrorOptional)?"component-formInput-inputHasError ":""), 
                                name: inputName,
                                onClick:(e)=>{ if (isInputClickHandlingRequired) this.handleInputClick(e); },
                                onFocus:(e)=>{ if (isInputFocusHandlingRequired) this.handleInputFocus(e); }, 
                                onKeyPress:(e)=>{ if (isInputKeyPressHandlingRequired) this.handleInputKeyPress(e); }, 
                                onBlur:(e)=>{ if (isInputBlurHandlingRequired) this.handleInputBlur(e); },
                                
                                autoComplete: "off", 
                                maxLength:((inputMaxLength)?inputMaxLength:524288), 
                                placeholder:((inputPlaceholder)?inputPlaceholder:""), 
                                disabled:(isInputDisabled), 
                                
                                ...inputCustomOptions_formatted
                            }} 
                            defaultValue={inputValue} 
    
                            {...passwordStrengthOptions_formatted} 
                            
                            changeCallback={(passwordObj)=> this.handleInputChange(passwordObj)} 
                            ref={this.resetPasswordField} 
                        />
                    )}
                    
                    {/* Error Message */}
                    {(isErrorOptional)?"":(errorDisplay)}
                    
                    {/* Custom Error Message */}
                    {(customErrorDisplay)?customErrorDisplay:""}

                    {/* Forgot Password */}
                    {isForgotPasswordRequired? (
                        <div className={"d-flex justify-content-end"}>
                            <span className={"component-formInputPassword-forgotPassword " +
                                    (forgotPasswordClassName? forgotPasswordClassName + " ":"")}
                                onClick={this.props.handleOnClick_forgotPassword}
                            >
                                Forgot Password?
                            </span>
                        </div>
                    ):""}
                
                </div>
            </FormInput>
        );
    }
}



const FormInput_password = FormInput_passwordPresentation;
export { FormInput_password };